import BaseStorageService from './base';

class GlobalStorage extends BaseStorageService {
  setLocalTheme(theme: string) {
    this.setItem('theme', theme);
  }

  getLocalTheme() {
    return this.getItem('theme');
  }

  getTrackCommonData() {
    return this.getItem('trackCommonData');
  }

  clearLocalTheme() {
    this.removeItem('theme');
  }
}

export default GlobalStorage;
